// Theme colors
export const COLORS = {
  PRIMARY: '#212529',
  SECONDARY: '#666',
  BACKGROUND: '#fff',
  BORDER: 'white',
  INDICATOR: '#212529',
}

// Typography
export const TYPOGRAPHY = {
  FONT_FAMILY: 'Inter',
  FONT_WEIGHT: {
    SEMIBOLD: 600,
    BOLD: 700,
  },
  FONT_SIZE: {
    TAB: '16px',
    TITLE: '18px',
  },
}

// Modal dimensions
export const MODAL_DIMENSIONS = {
  WIDTH: {
    DESKTOP: 480,
    MOBILE: 345,
  },
}

// Tab configuration
export const TAB_STYLES = {
  BACKGROUND_COLOR: COLORS.BACKGROUND,
  MARGIN_BOTTOM: '30px',
  LABEL: {
    FONT_FAMILY: TYPOGRAPHY.FONT_FAMILY,
    FONT_WEIGHT: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    FONT_SIZE: TYPOGRAPHY.FONT_SIZE.TAB,
    TEXT_TRANSFORM: 'none',
    COLOR: COLORS.SECONDARY,
    SELECTED_COLOR: COLORS.PRIMARY,
  },
  INDICATOR: {
    BACKGROUND_COLOR: COLORS.INDICATOR,
  },
}
